import React, { useState } from "react";
import CustomModal from "../../modal";
import Prompt from "../../modal/prompt";
import { useTranslation } from "react-i18next";
import { IoCloseOutline, IoTrash } from "react-icons/io5";
import { Range, getTrackBackground } from "react-range";
import { formatTime } from "../../../utils/functions";

import { useSelector, useDispatch } from "react-redux";
import {
  setVisible,
  setDesafio,
  setIdDesafio,
  setQuemFaz,
  setTempo,
} from "../../../store/slices/customSoloChallenge";

import styles from "./soloModals.module.css";

export default function AddChallengeSolo({ keepForm, onSave, onRemove }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [confirm, setConfirm] = useState(false);
  const { visible, desafio, id_desafio, quemFaz, tempo } = useSelector(
    (state) => state.customSoloChallenge
  );

  const handleClose = () => {
    dispatch(setVisible(false));
  };

  const handleSave = () => {
    // if (!title || !description) {
    //   if (!title)
    //     document
    //       .getElementById("category-input")
    //       .classList.add(styles["input-error"]);
    //   if (!description)
    //     document
    //       .getElementById("description-input")
    //       .classList.add(styles["input-error"]);
    //   return;
    // }

    onSave({
      id_desafio,
      desafio,
      quemFaz,
      tempo,
    });
    handleClose();
  };

  const handleShouldRemove = () => {
    setConfirm(true);
  };

  const handleRemove = () => {
    setConfirm(false);
    setTimeout(() => {
      onRemove(id_desafio);
      handleClose();
    }, 300);
  };

  const afterClose = () => {
    if (keepForm) return;
    dispatch(setDesafio(""));
    dispatch(setIdDesafio(0));
    dispatch(setQuemFaz(0));
    dispatch(setTempo(0));
  };

  const onFocus = (e) => {
    e.target.classList.remove(styles["input-error"]);
  };

  return (
    <div>
      <CustomModal
        className="w-full"
        visible={visible}
        handleClose={handleClose}
        handleAfterClose={afterClose}
      >
        <div className={styles.card}>
          <div className="flex justify-between items-center">
            <button
              className="pt-3 -mt-3 ps-3 -ms-3 touchable-opacity"
              onClick={handleClose}
            >
              <IoCloseOutline size={32} />
            </button>
            {id_desafio ? (
              <button
                className="pt-3 -mt-3 pe-3 -me-3 touchable-opacity"
                onClick={handleShouldRemove}
              >
                <IoTrash size={22} />
              </button>
            ) : null}
          </div>
          <hr className="border-[#6A6C71]" />
          <div className="flex flex-col gap-5 mt-3">
            <div className="flex flex-col">
              <label className={styles.label}>{t("dare")}</label>
              <textarea
                rows={3}
                className={styles.input}
                value={desafio}
                id="description-input"
                onFocus={onFocus}
                onChange={(e) => dispatch(setDesafio(e.target.value))}
              />
            </div>
            <div className="flex flex-col">
              <label className={styles.label}>{t("textoeditDesafio")}</label>
              <div className={styles.radioGroup}>
                <div className="flex flex-1 items-center">
                  <input
                    type="radio"
                    id="ambos"
                    className="hidden"
                    checked={quemFaz === 0}
                    onChange={() => dispatch(setQuemFaz(0))}
                  />
                  <label htmlFor="ambos" className={styles.radio}>
                    {t("ambos")}
                  </label>
                </div>
                <div className="flex flex-1 items-center">
                  <input
                    type="radio"
                    id="male"
                    className="hidden"
                    checked={quemFaz === 1}
                    onChange={() => dispatch(setQuemFaz(1))}
                  />
                  <label htmlFor="male" className={styles.radio}>
                    {t("male")}
                  </label>
                </div>
                <div className="flex flex-1 items-center">
                  <input
                    type="radio"
                    id="female"
                    className="hidden"
                    checked={quemFaz === 2}
                    onChange={() => dispatch(setQuemFaz(2))}
                  />
                  <label htmlFor="female" className={styles.radio}>
                    {t("female")}
                  </label>
                </div>
              </div>
            </div>
            <div className="flex flex-col mb-10">
              <label className={styles.label}>
                {t("time")} {formatTime(tempo)}
              </label>
              <div className="mt-2 ms-2 me-2">
                <Range
                  step={30}
                  min={0}
                  max={900}
                  values={[tempo]}
                  onChange={(values) => dispatch(setTempo(values[0]))}
                  renderTrack={({ props, children }) => (
                    <div
                      {...props}
                      style={{
                        ...props.style,
                        height: "5px",
                        width: "100%",
                        borderRadius: "5px",
                        background: getTrackBackground({
                          values: [tempo],
                          colors: ["#D87070", "#d9d9d9"],
                          min: 0,
                          max: 900,
                          step: 30,
                        }),
                      }}
                    >
                      {children}
                    </div>
                  )}
                  renderThumb={({ props }) => (
                    <div
                      {...props}
                      key={props.key}
                      style={{
                        ...props.style,
                        height: "20px",
                        width: "20px",
                        borderRadius: "50%",
                        backgroundColor: "white",
                      }}
                    />
                  )}
                />
              </div>
            </div>
            <button
              onClick={handleSave}
              className="btn btn-brand btn-small pt-2 pb-2"
            >
              {t("save")}
            </button>
          </div>
        </div>
      </CustomModal>
      <Prompt
        visible={confirm}
        title={"Tem certeza?"}
        description={"Isso excluira permanentemente este desafio"}
        handleConfirm={handleRemove}
        handleCancel={() => setConfirm(false)}
      />
    </div>
  );
}
